// Íconos de línea del ERP (24×24, trazo 1,8): uno por módulo y unos pocos de la barra. Dibujados aquí
// para no sumar una dependencia; heredan el color del texto (currentColor).
const TRAZOS: Record<string, string> = {
  inicio: 'M3 11.5 12 4l9 7.5M5.5 9.5V20h5v-6h3v6h5V9.5',
  ventas: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3',
  compras: 'M3 4h2.5l2.2 11h10.6L20.5 7H6.6M9 20h.01M17 20h.01',
  stock: 'M12 3 3.5 7.5v9L12 21l8.5-4.5v-9zM3.5 7.5 12 12l8.5-4.5M12 12v9',
  clientes:
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c.6-3.6 3.2-5.5 6.5-5.5s5.9 1.9 6.5 5.5M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14.8c2 .7 3.2 2.4 3.5 5.2',
  proveedores: 'M3 21V10l5 3V10l5 3V10l5 3V6h3v15zM7 17h2M12 17h2M17 17h2',
  operaciones:
    'M2.5 6h11v10h-11zM13.5 9.5h4l3 3.5v3h-7M6 19.5a1.8 1.8 0 1 0 0-.1M17 19.5a1.8 1.8 0 1 0 0-.1',
  cobros: 'M3.5 9h17v11h-17zM3.5 13h17M16.5 16.5h.01M12 2v5M9.5 4.5 12 7l2.5-2.5',
  pagos: 'M3.5 9h17v11h-17zM3.5 13h17M16.5 16.5h.01M12 7V2M9.5 4.5 12 2l2.5 2.5',
  tesoreria: 'M3.5 7h17v12h-17zM3.5 7l2.5-3h12l2.5 3M16 13h.01M3.5 11h17',
  dte: 'M7 3h7l4 4v14H7zM14 3v4h4M9.5 14l2 2 3.5-4',
  informes: 'M4 20V4M4 20h16M8 16v-5M12 16V8M16 16v-3',
  gerencia: 'M3.5 20h17M5 16l4.5-5 3.5 3 6-7M15 7h4v4',
  maestros:
    'M12 3c4.4 0 8 1.3 8 3s-3.6 3-8 3-8-1.3-8-3 3.6-3 8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  configuracion:
    'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM19 12l2-1-1-3-2.2.3-1.3-1.3L16.8 5l-3-1-1 2h-1.6l-1-2-3 1 .3 2.2L6.2 8.5 4 8.2l-1 3 2 1v1.6l-2 1 1 3 2.2-.3 1.3 1.3-.3 2.2 3 1 1-2h1.6l1 2 3-1-.3-2.2 1.3-1.3 2.2.3 1-3-2-1z',
  buscar: 'M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM20 20l-4.8-4.8',
  expandir: 'M9 6l6 6-6 6',
  contraer: 'M15 6l-6 6 6 6',
  estrella: 'M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8-4.3-4.1 5.9-.8z',
  mas: 'M6 9l6 6 6-6',
  campana: 'M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15zM10 20.5h4',
};

export function Icono({
  nombre,
  tamano = 18,
  relleno = false,
}: {
  nombre: string;
  tamano?: number;
  relleno?: boolean;
}) {
  return (
    <svg
      className={`icono icono-${nombre}`}
      width={tamano}
      height={tamano}
      viewBox="0 0 24 24"
      fill={relleno ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <path d={TRAZOS[nombre] ?? ''} />
    </svg>
  );
}
